import React from "react";
import PanDetails from "../../../_utils/AccountCreationComponents/PanDetails";

const VerifyUserPan = ({
  verifyPANisLoading,
  panNumber,
  panDetails,
  verifiedPan,
  handlePanChange,
}) => {
  return (
    <div className="Qlg:w-width-md w-width-full  Qlg:pr-padding-md   Qlg:px-padding-base  px-padding-md Qsmd:pt-padding-base pt-padding-md">
      {" "}
      <PanDetails
        verifiedPan={verifiedPan}
        verifyPANisLoading={verifyPANisLoading}
        panNumber={panNumber}
        handlePanChange={(e) => {
          handlePanChange(e);
        }}
        panDetails={panDetails}
      />
    </div>
  );
};

export default VerifyUserPan;
